// eslint-disable no-unused-prop-types
import React from 'react'
import { Box, Snackbar as MUISnackbar, Typography } from '@mui/material'

interface SnackbarProps {
  open: boolean
  onClose?: () => void
  message: string
  status: 'error' | 'success' | 'warning'
  duration?: number
}

export const SnackBar: React.FC<SnackbarProps> = ({
  open,
  onClose,
  message,
  status,
  duration = 3000
}) => {
  return (
    <Box
      sx={(theme) => ({
        width: '100%',
        '& > * + *': {
          marginTop: theme.spacing(2)
        }
      })}
    >
      <MUISnackbar open={open} autoHideDuration={duration} onClose={onClose}>
        <Alert message={message} status={status} />
      </MUISnackbar>
    </Box>
  )
}

interface AlertProps {
  message: string
  status: string
}

const Alert: React.FC<AlertProps> = ({ message, status }) => {
  const statusStyles: Record<string, { backgroundColor: string; color: string }> = {
    error: { backgroundColor: '#f44336', color: 'white' },
    success: { backgroundColor: '#4caf50', color: 'black' },
    warning: { backgroundColor: '#ffea2f', color: 'black' }
  }
  const style = statusStyles[status] || statusStyles.error
  return (
    <Box
      sx={{
        p: '20px',
        backgroundColor: style.backgroundColor,
        color: style.color
      }}
    >
      <Typography variant='button'>{message}</Typography>
    </Box>
  )
}
